import "@/App.css";
import "@/marsem.css";
import "@/marsem-fixes.css";
import "@/premium-redesign.css";
import "@/premium-mobile-fixes.css";
import "@/cta-editor-fixes.css";
import "@/accessibility-polish.css";
import "@/top-navigation.css";
import "@/student-resources.css";
import "@/visual-editor.css";
import "@/production-upgrade.css";
import "@/admin-management.css";
import "@/rounded-polish.css";
import "@/mobile-learning-upgrade.css";
import "@/profile-settings.css";
import "@/admin-insights.css";
import "@/engagement-upgrade.css";
import "@/final-experience.css";
import "@/automation-studio.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { TopAppShell as AppShell } from "@/components/TopAppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CoursesPage from "@/pages/CoursesPage";
import CoursePlayerPage from "@/pages/CoursePlayerV2";
import CourseEditorPage from "@/pages/CourseEditorV2";
import HomeworkPage from "@/pages/HomeworkPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import UsersPage from "@/pages/UsersPage";
import StudentFeaturePage from "@/pages/StudentFeaturePage";
import CertificatesPage from "@/pages/CertificatesPage";
import CertificateVerifyPage from "@/pages/CertificateVerifyPage";
import ProfilePage from "@/pages/ProfilePage";
import BrandingPage from "@/pages/BrandingPage";
import FunnelsPage from "@/pages/FunnelsPage";

function ProtectedApp() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="boot" data-testid="app-loading-state">
        MARSEM LAB
        <span />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell />;
}

function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (!roles.includes(user?.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="dark">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/verify-certificate/:token"
              element={<CertificateVerifyPage />}
            />
            <Route element={<ProtectedApp />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/kursy" element={<CoursesPage />} />
              <Route path="/kursy/:courseId" element={<CoursePlayerPage />} />
              <Route
                path="/admin/kursy/nowy"
                element={
                  <RoleRoute roles={["admin"]}>
                    <CourseEditorPage />
                  </RoleRoute>
                }
              />
              <Route
                path="/admin/kursy/:courseId"
                element={
                  <RoleRoute roles={["admin"]}>
                    <CourseEditorPage />
                  </RoleRoute>
                }
              />
              <Route path="/zadania" element={<HomeworkPage />} />
              <Route path="/profil" element={<ProfilePage />} />
              <Route
                path="/moduly"
                element={
                  <RoleRoute roles={["student"]}>
                    <StudentFeaturePage />
                  </RoleRoute>
                }
              />
              <Route
                path="/bonusy"
                element={
                  <RoleRoute roles={["student"]}>
                    <StudentFeaturePage />
                  </RoleRoute>
                }
              />
              <Route
                path="/spolecznosc"
                element={
                  <RoleRoute roles={["student"]}>
                    <StudentFeaturePage />
                  </RoleRoute>
                }
              />
              <Route
                path="/certyfikaty"
                element={
                  <RoleRoute roles={["student"]}>
                    <CertificatesPage />
                  </RoleRoute>
                }
              />
              <Route
                path="/uzytkownicy"
                element={
                  <RoleRoute roles={["admin"]}>
                    <UsersPage />
                  </RoleRoute>
                }
              />
              <Route
                path="/wyglad"
                element={
                  <RoleRoute roles={["admin"]}>
                    <BrandingPage />
                  </RoleRoute>
                }
              />
              <Route
                path="/integracje"
                element={
                  <RoleRoute roles={["admin"]}>
                    <IntegrationsPage />
                  </RoleRoute>
                }
              />
              <Route
                path="/lejki"
                element={
                  <RoleRoute roles={["admin"]}>
                    <FunnelsPage />
                  </RoleRoute>
                }
              />
            </Route>
          </Routes>
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
